
document.addEventListener('DOMContentLoaded', function(e) {
  var mainHeader = document.getElementsByClassName('js_topBar')[0];
  var stickyOffset = mainHeader.offsetTop;

  window.onscroll = function() {
    if (window.pageYOffset > stickyOffset) {
      document.body.classList.add('sticky');
    } else {
      document.body.classList.remove('sticky');
    }
  };

});
